import { ProfileService } from './../profile.service';
import { DeleteProfileAttachmentDialogComponent } from './../delete-profile-attachment-dialog/delete-profile-attachment-dialog.component';
import { Subscription } from 'rxjs';
import { AddProfileAttachmentDialogComponent } from './../add-profile-attachment-dialog/add-profile-attachment-dialog.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Attachment } from './../../../shared-components/models/attachment.model';
import { Component, Inject, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { ProfileAttachment } from '../profile-attachment.model';
import { System } from '../../System';
import {Profile} from '../profile.model';
import { LoginService } from '../../../shared-modules/login/login.service';
import { UserService } from '../../user/user.service';
import { UserType } from '../../user/user-type';

@Component({
    selector: 'attachments-menu',
    templateUrl: './attachments-menu-dialog.component.html',
    styleUrls: [
        './attachments-menu-dialog.component.css'
    ]
})
export class AttachmentsMenuDialogComponent implements OnInit, OnDestroy {

    // Properties
    attachments: Attachment[] = [];
    tableData: TylerMatTableDataSource;
    columns = ['name', 'description', 'attached', 'visible to parents students', 'actions'];
    subscriptions: Subscription[] = [];
    userCanAdd = false;
    profile: Profile;
    V10: boolean;
    attachmentChanged = new EventEmitter<any>();

    // Class Functions
    constructor(
        private dialogBox: MatDialogRef<AttachmentsMenuDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialog: MatDialog,
        private profileService: ProfileService,
        private loginService: LoginService,
        private userService: UserService
    ) { }

    // Event Functions
    ngOnInit() {
        this.V10 = this.loginService.LoginSettings.V10;
        if (this.data.attachments) {
            this.attachments = this.data.attachments;
        } else {
            this.attachments = [];
        }
        this.profile = this.data.profile;
        // For V9 - When logged in with parent/student only show attachments those are Allow parent to view 
        if (this.userService.currentUser.UserType != UserType.Staff) {
            this.profile.ProfileAttachments = this.profile.parentViewableAttachments;
        }
        this.userCanAdd = this.data.userCanAdd;
        if (!this.userCanAdd) {
            this.columns.splice(this.columns.indexOf('actions'), 1);
        }
        this.tableData = new TylerMatTableDataSource(this.attachments);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }

    addAttachment() {
        // PRE: the add attachment is clicked
        // POST: shows the add attachment dialog
        const attachment = new ProfileAttachment();
        attachment.FileType = '';
        attachment.FileExtension = '';
        attachment.Description = '';
        attachment.DocOwnerID = this.profile.ProfileContentId;
        attachment.FolderID = -1;
        attachment.FileID = -1;
        attachment.AllowParentToView = true;
        attachment.TableID = 18;
        attachment.MyFileName = '';
        attachment.OriginalFileName = '';
        attachment.DateAttached = new Date();
        attachment.ContentID = this.profile.ProfileContentId
        const dialogBox = this.dialog.open(AddProfileAttachmentDialogComponent, {
            data: {
                attachment: attachment
            },
            disableClose: true
        });
        this.subscriptions.push(
            dialogBox.afterClosed().subscribe(() => {
                if (dialogBox.componentInstance.saved) {
                    if (this.V10) {
                        this.attachments.push(attachment);
                        this.tableData = new TylerMatTableDataSource(this.attachments);
                    }
                    else {
                        this.profile.ProfileAttachments.push(dialogBox.componentInstance.attachment)
                        this.attachmentChanged.emit();
                    }
                }
            })
        );
    }

    close() {
        // PRE: the close button is clicked
        // POST: closes the dialog box
        this.dialogBox.close();
    }

    // Methods
    downloadAttachment(attachment: ProfileAttachment) {
        // PRE: an attachment to view
        // POST: downloads the attachment to the user
        console.log(attachment);
        this.subscriptions.push(
            this.profileService.getAttachmentFile(attachment.FileID).subscribe(result => {
                console.log(result);
                const filename = this.V10 ? result.MyFileName + '.' + result.FileExtension : result.MyFileName;
                System.saveFile(result.MyFile, result.FileType, filename);
            })
        );
    }

    editAttachment(attachment: ProfileAttachment) {
        // PRE: an attachment to edit
        // POST: opens the dialog for editing the attachment
        const changedAttachment = Object.assign(new ProfileAttachment, attachment);
        changedAttachment.ContentID = this.profile.ProfileContentId;
        const dialogBox = this.dialog.open(AddProfileAttachmentDialogComponent, {
            data: {
                attachment: changedAttachment
            },
            disableClose: true
        });
        this.subscriptions.push(
            dialogBox.afterClosed().subscribe(() => {
                if (dialogBox.componentInstance.saved) {
                    Object.assign(attachment, changedAttachment);
                }
            })
        );
    }

    deleteAttachment(attachment: ProfileAttachment) {
        // PRE: an attachment to delete
        // POST: opens the dialog for deleting the attachment
        attachment.ContentID = this.profile.ProfileContentId;
        const dialogBox = this.dialog.open(DeleteProfileAttachmentDialogComponent, {
            data: {
                attachment: attachment
            },
            disableClose: true
        });
        this.subscriptions.push(
            dialogBox.afterClosed().subscribe(() => {
                if (dialogBox.componentInstance.deleted) {
                    this.attachments.splice(this.attachments.indexOf(attachment), 1);
                    this.tableData = new TylerMatTableDataSource(this.attachments);
                }
            })
        );
    }
}